import { Feature } from "@evergis/sgis";
import { Crs } from "@evergis/sgis/es/Crs";
import { Polygon } from "@evergis/sgis/es/features/Polygon";
import { Polyline } from "@evergis/sgis/es/features/Polyline";
import { ShadowedPolySymbol } from "../../../../../../react-sgis/symbols/editorSymbols/ShadowedPolySymbol";
import { polylineLikePolygon } from "../../../../../../react-sgis/utils";

export const createPolylineFeature = (
  rings: [number, number][][],
  crs: Crs,
  resolution: number,
  polygonEditSymbol: ShadowedPolySymbol,
  polygonCreateSymbol: ShadowedPolySymbol,
  polylineEditSymbol: ShadowedPolySymbol,
  polylineCreateSymbol: ShadowedPolySymbol,
  isEdit?: boolean,
): Feature | Feature[] => {
  let feature;

  if (polylineLikePolygon(rings, resolution)) {
    rings[0].shift();
    feature = new Polygon(rings, { crs });
    feature.symbol = isEdit ? polygonEditSymbol.clone() : polygonCreateSymbol.clone();
  } else {
    feature = new Polyline(rings, { crs });
    feature.symbol = isEdit ? polylineEditSymbol.clone() : polylineCreateSymbol.clone();
  }

  return feature;
};
